<!-- Loading Skeleton -->
<div
  *ngIf="loading"
  [class]="sizeClasses() + ' rounded-full bg-gray-200 animate-pulse ' + customClass"
  [attr.aria-label]="'Loading avatar'"
></div>

<!-- Avatar Image -->
<img
  *ngIf="!loading && finalAvatarUrl && !imageError()"
  [src]="finalAvatarUrl"
  [alt]="altText"
  [class]="sizeClasses() + ' rounded-full object-cover ' + borderClasses + ' ' + customClass"
  (error)="onImageError()"
  (load)="onImageLoad()"
  loading="lazy"
/>

<!-- Initials Fallback -->
<div
  *ngIf="!loading && (!finalAvatarUrl || imageError())"
  [class]="sizeClasses() + ' rounded-full flex items-center justify-center font-semibold select-none ' + borderClasses + ' ' + customClass"
  [style.backgroundColor]="backgroundColor()"
  [style.color]="textColor()"
  [attr.aria-label]="altText"
  role="img"
>
  {{ initials() }}
</div>

